<template>
  <div class="content">
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="bind2FAModal"
      title="綁定2FA"
    >
      <div class="modalBody bind2FA">
        <vue-qrcode
          :margin="1"
          :value="
            encodeURI(`otpauth://totp/${returnName()}?secret=${FAData.secret}`)
          "
          :width="250"
        />
        <el-form
          @submit.native.prevent
          :model="{}"
          autocomplete="on"
          style="width:100%"
          label-position="left"
        >
          <el-form-item label="密钥">
            <el-input :value="FAData.secret" />
            <el-button
              size="mini"
              v-clipboard:copy="FAData.secret"
              style="margin-top:20px;"
              v-clipboard:success="$onCopy"
              >複製</el-button
            >
          </el-form-item>
          <el-form-item label="驗證碼">
            <el-input
              v-model="oneCode"
              type="number"
              placeholder="驗證碼"
              name="password"
              tabindex="2"
              autocomplete="on"
              @blur="capsTooltip = false"
              @keyup.enter.native="confirmBind2FA()"
            />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="bind2FAModal = false" class="btn">取消</div>
        <div @click="confirmSet2FA" class="btn">綁定</div>
      </div>
    </el-dialog>
    <h3 class="title">
      HI <span>{{ selfInfo.name }}</span
      >！
    </h3>
    <h3 class="title">
      您登入的身份為 <span>{{ selfInfo.role_name_ch }}</span
      >！
    </h3>
  </div>
</template>
<script>
import VueQrcode from "vue-qrcode";
export default {
  components: {
    VueQrcode
  },
  data() {
    return {
      FAData: {},
      oneCode: "",
      bind2FAModal: false
    };
  },
  computed: {
    selfInfo() {
      return this.$store.state.selfInfo;
    }
  },
  methods: {
    confirmSet2FA() {
      this.$http
        .post(`/back/2FA`, {
          oneCode: this.oneCode
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("綁定成功");
            this.bind2FAModal = false;
            this.$router.push("/selfData");
          }
        });
    },
    returnName() {
      return "后台" + "-" + this.$store.state.selfInfo.username;
    },
    getFA() {
      this.$http.get(`/back/2FA`).then(res => {
        if (res.data.code == 0) {
          this.bind2FAModal = true;
          this.FAData = res.data.data;
        }
      });
    }
  },
  created() {
    if (this.$route.query?.bind) {
      this.getFA();
    }
  }
};
</script>
<style lang="scss" scoped>
h3 {
  padding: 10px;
}
span {
  color: #409eff;
}

.bind2FA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  img {
    width: 150px;
  }
}
</style>
